<template>
  <ProgramPage />
</template>

<script>
import faviconUrl from "./assets/logo.png";
import ProgramPage from "./components/ProgramPage.vue";

export default {
  name: "App",
  components: { ProgramPage },
  mounted() {
    const existing = document.querySelector('link[rel="icon"]');
    const link = existing || document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.href = faviconUrl;
    if (!existing) document.head.appendChild(link);
  },
};
</script>

<style>
#app {
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
}
</style>
